import type { EpiSocketStatus } from '../hooks/useEpiStudyAgentSocket';

/**
 * Derive the chat composer's "still loading" message (OR-6139 AC 2) from the
 * session's load state. ``null`` means the composer is ready to accept a
 * submit; a non-null string is shown as the Send-button tooltip while typing
 * stays allowed.
 *
 * Order is deliberate:
 *  - Disconnected → ``null``. The composer stays submittable while offline (a
 *    submit routes to the queue and flushes on reconnect) and a connection
 *    alert is surfaced elsewhere, so a loading tooltip would be noise.
 *  - ``initializing`` (the brand-new-session welcome stream) takes priority and
 *    shows the agent-initializing copy.
 *  - ``!subscribeAcked`` (the subscribe handshake hasn't been acked) shows the
 *    chat-loading copy, so a resumed session can't be submitted into before its
 *    in-flight run state is known.
 *
 * Single source of truth for ``EpiChatPanelLayout``'s composer gating.
 */
export const composerLoadingMessage = (
  status: EpiSocketStatus,
  initializing: boolean,
  subscribeAcked: boolean
): string | null => {
  if (status !== 'connected') return null;
  if (initializing) return 'Initializing Research Assistant…';
  if (!subscribeAcked) return 'Loading this chat…';
  return null;
};
